import * as React from "react";
import type { SVGProps } from "react";
const SvgCustomLine = (props: SVGProps<SVGSVGElement>) => (
    <svg width="265" height="2" viewBox="0 0 265 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <line y1="0.527588" x2="265" y2="0.527588" stroke="#8B8B8B" stroke-opacity="0.24"/>
    </svg>
)
export default SvgCustomLine;








